import { BankAccount, SidebarItem } from "../types";
// Theme
export const THEME_SET = "THEME_SET";
export const THEMES = {
  DEFAULT: "DEFAULT",
  DARK: "DARK",
  LIGHT: "LIGHT",
  BLUE: "BLUE",
  GREEN: "GREEN",
  INDIGO: "INDIGO",
};

// Auth
export const AUTH_SIGN_IN_REQUEST = "AUTH_SIGN_IN_REQUEST";
export const AUTH_SIGN_IN_SUCCESS = "AUTH_SIGN_IN_SUCCESS";
export const AUTH_SIGN_IN_FAILURE = "AUTH_SIGN_IN_FAILURE";
export const AUTH_SIGN_OUT = "AUTH_SIGN_OUT";
export const AUTH_SIGN_UP_REQUEST = "AUTH_SIGN_UP_REQUEST";
export const AUTH_SIGN_UP_SUCCESS = "AUTH_SIGN_UP_SUCCESS";
export const AUTH_SIGN_UP_FAILURE = "AUTH_SIGN_UP_FAILURE";
export const AUTH_RESET_PASSWORD_REQUEST = "AUTH_RESET_PASSWORD_REQUEST";
export const AUTH_RESET_PASSWORD_SUCCESS = "AUTH_RESET_PASSWORD_SUCCESS";
export const AUTH_RESET_PASSWORD_FAILURE = "AUTH_RESET_PASSWORD_FAILURE";
export const AUTH_USER_BALANCE_UPDATE_SUCCESS =
  "AUTH_USER_BALANCE_UPDATE_SUCCESS";
export const AUTH_USER_BALANCE_UPDATE_FAILURE =
  "AUTH_USER_BALANCE_UPDATE_FAILURE";
export const AUTH_USER_BALANCE_UPDATE_REQUEST =
  "AUTH_USER_BALANCE_UPDATE_REQUEST";

// Map
export const MAP_MARKERS_LOAD_SUCCESS = "MAP_MARKERS_LOADED_SUCCESS";
export const MAP_MARKERS_LOAD_FAILURE = "MAP_MARKERS_LOADED_FAILURE";
export const ADD_SELECTED_ZONE = "ADD_SELECTED_ZONE";

export const CAMPAIGN_CREATION_SUCCESS = " CAMPAIGN_CREATION_SUCCESS";
export const CAMPAIGN_CREATION_FAILURE = " CAMPAIGN_CREATION_FAILURES";

export const BANK_ACCOUNTS: BankAccount[] = [
  {
    id: "acap",
    bankName: "Asociación Cibao",
    bankType: "Ahorros y Préstamos",
    accountHolder: "Wifiads Media Networks",
    accountType: "Savings Account",
    rncId: "123456789",
    currency: "DOP, Pesos Dominicanos",
    accountNumber: "100020315855",
    logoColor: "text-blue-400",
    logoLabel: "ACAP",
    iconName: "account_balance",
  },
  {
    id: "popular",
    bankName: "Banco Popular",
    bankType: "Dominicano",
    accountHolder: "Wifiads Media Networks",
    accountType: "Current Account",
    rncId: "123456789",
    currency: "DOP, Pesos Dominicanos",
    accountNumber: "12052855",
    logoColor: "text-emerald-400",
    logoLabel: "POPULAR",
    iconName: "account_balance",
  },
];

export const SIDEBAR_ITEMS: SidebarItem[] = [
  { id: "dashboard", label: "Dashboard", icon: "dashboard" },
  { id: "campañas", label: "Campañas", icon: "campaign" },
  { id: "pagos", label: "Pagos", icon: "payments", isActive: true },
  { id: "localizaciones", label: "Localizaciones", icon: "location_on" },
  { id: "encuesta", label: "Encuesta", icon: "poll", hasSubmenu: true },
  { id: "configuraciones", label: "Configuraciones", icon: "settings" },
];
